export function parseKeycloakProfile(claims) {
  if (!claims) {
    return { email: null, username: null, profile: {} };
  }

  const profile = { ...claims };

  if (profile.groups?.length) {
    profile.groups = profile.groups.map((group) => group.replace("/", ""));
  }

  if (profile.operation_access && typeof profile.operation_access === "string") {
    profile.operation_access = profile.operation_access.split(",");
  }

  const email = profile.email;
  const username =
    profile.given_name || profile.preferred_username || profile.name;

  return { email, username, profile };
}

function normalizeProfileForCompare({ email, username, profile }) {
  return {
    email: email || null,
    username: username || null,
    groups: [...(profile?.groups || [])].sort(),
    operation_access: [...(profile?.operation_access || [])].sort(),
  };
}

export function getProfileKey({ email, username, profile }) {
  return JSON.stringify(normalizeProfileForCompare({ email, username, profile }));
}

export function hasProfileChanged(previous, current) {
  if (!previous?.profile || !Object.keys(previous.profile).length) {
    return !!(current?.profile && Object.keys(current.profile).length);
  }

  return (
    JSON.stringify(normalizeProfileForCompare(previous)) !==
    JSON.stringify(normalizeProfileForCompare(current))
  );
}
